import React, { Dispatch, SetStateAction } from 'react'

import { HiOutlinePlus } from 'react-icons/hi'
import { LuPanelBottomOpen, LuPanelTopOpen } from 'react-icons/lu'
import { useNavigate } from 'react-router-dom'

import { useStudents, useUser } from '../../../context'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { Student, Profesor } from '../../../types'
import { Spacer } from '../../global'
import Search from '../../search/Search'
import { SectionSubtitle } from '../../texts'
import { NewUserButton } from '../../users/administration/styles'
import ListWithImage from '../listWithImage/ListWithImage'

import {
  List,
  ListContainer,
  ListIcon,
  ListIconTitle,
  TitleContainer,
} from './styles'

const ListWithSearch = ({
  type,
  searchValue,
  filteredStudents,
  setSearchValue,
  selectStudent,
  showList,
  setShowList,
}: {
  type: string
  searchValue: string
  filteredStudents: Student[] | null
  setSearchValue: Dispatch<SetStateAction<string>>
  selectStudent: (student: Profesor | Student) => void
  showList: boolean
  setShowList: Dispatch<SetStateAction<boolean>>
}) => {
  const navigate = useNavigate()
  const { onEditionMode } = useUser()
  const { activeStudent, studentsList } = useStudents()
  const { isMobile } = useWindowSize()

  const handleSelect = (index: number) => {
    studentsList && selectStudent(studentsList[index])
  }

  return (
    <ListContainer className={`${isMobile && showList ? 'open' : ''}`}>
      {!isMobile && <Spacer height={15} />}
      <TitleContainer>
        <SectionSubtitle
          fontWeight={600}
          fontSize={16}
          lineHeight={24}
          className="title"
        >
          <ListIconTitle>
            Seleccione un {type}
            <ListIcon onClick={() => setShowList(!showList)}>
              {showList ? <LuPanelBottomOpen /> : <LuPanelTopOpen />}
            </ListIcon>
          </ListIconTitle>
        </SectionSubtitle>

        {showList && (
          <>
            <Spacer height={10} />
            <Search searchValue={searchValue} setSearchValue={setSearchValue} />
          </>
        )}
      </TitleContainer>
      <List className={`${isMobile && showList ? 'open' : ''}`}>
        <Spacer height={10} />
        <ListWithImage
          disabled={onEditionMode}
          list={filteredStudents ?? studentsList}
          onClick={handleSelect}
          activeId={activeStudent && activeStudent.uid}
        />

        <NewUserButton $hasSeparation={true}>
          <button
            type="button"
            onClick={() => navigate('/nuevo-usuario?user=student')}
          >
            <HiOutlinePlus />
          </button>
          <p>Añadir {type.charAt(0).toUpperCase() + type.slice(1)}</p>
        </NewUserButton>
      </List>
    </ListContainer>
  )
}

export default ListWithSearch
